import ArchPropertiesPane from '../_ARCH/ArchPropertiesPane.jsx'
import ButtonImportProductsFromXls from '../_DESIGN/PropertiesPaneButtonImportProductsFromXls.jsx'

export default function PropertiesPanePa(props) {
    const buttons = <>
        <ButtonImportProductsFromXls type="pm">
            导入知识结构
        </ButtonImportProductsFromXls>
    </>

    return (
        <ArchPropertiesPane
            buttons={buttons}
            {...props}
        />
    )
}
